import axios from 'axios';
import { LineConfig, ResponseGetLineConfig } from '../schemas/LineConfig.schema';

const authHeader = () => ({
    Authorization: 'Bearer ' + localStorage.getItem('WF_APPLICATION')
});

export async function getLineConfig() {
    return axios.get<ResponseGetLineConfig>('/v1/line-config', {
        headers: authHeader()
    });
}

export async function updateLineConfig(body: LineConfig) {
    return axios.put<{ message: string }>('/v1/line-config', body, {
        headers: authHeader()
    });
}

export async function createLineConfig(body: LineConfig) {
    return axios.post<{ message: string }>('/v1/line-config', body, {
        headers: authHeader()
    });
}
